import React, { useEffect } from 'react';
import { CustomDatePicker, DateWrapper, MobDatePicker } from '../../style';
import { FlexCol } from './styles';
import { DatePicker } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  startDateMobile,
  endDateMobile
} from '../../actions';
import { DisplayFlex } from '../../../../../../CommonComponents/commonStyles';


// DatePicker Component
function DateSelectorComponent(props) {
  useEffect(() => {
    if (props.startDate && props.endDate) {
    }
  }, [props.startDate, props.endDate, props.tab]);

  function onChange(value, dateString) {
    props.strDate(dateString[0]);
    props.edDate(dateString[1])
  }

  function onStartDate(value, dateString) {
    props.strDate(dateString);
  }

  function onEndDate(value, dateString) {
    props.edDate(dateString);
  }
  function disabledDate(start) {
    if (props.tab == 3) {
      return (
        start &&
        moment()
          .add('years', 10)
          .isBefore(start)
      );
    }
    // Can not select days before today and today
    return (
      start &&
      moment()
        .endOf('day')
        .isBefore(start)
    );
  }

  return (
    <DateWrapper className={`ga-date-${props.tabKey}`}>
      {window.screen.availWidth < 576 ? (
        <DisplayFlex style={{ flexDirection: "column" }}>
          <MobDatePicker data-test = "startDate"
            id="startDate"
            format={"MM/DD/YYYY"}
            placeholder={["Start Date"]}
            onChange={onStartDate}
            defaultValue={props.defaultValue[0]}
            getCalendarContainer={() =>
              document.querySelector(`.ga-date-${props.tabKey}`)
            }
          />
          <MobDatePicker
          data-test = "endDate"
            id="endDate"
            format={"MM/DD/YYYY"}
            onChange={onEndDate}
            placeholder={["End Date"]}
            defaultValue={props.defaultValue[1]}
            disabledDate={disabledDate}
            getCalendarContainer={() =>
              document.querySelector(`.ga-date-${props.tabKey}`)
            }
          />  
        </DisplayFlex>
      ) : (
        <CustomDatePicker
          data-test = "dateFilter"
          id="dateFilter"
          format={"MM/DD/YYYY"}
          getCalendarContainer={() =>{       
            return document.querySelector(`.ga-date-${props.tabKey}`)
          }
          }
          placeholder={['Start Date', 'End Date']}
          defaultValue={[moment().subtract('months', 1), moment()]}
          disabledDate={disabledDate}
          separator='~'
          open={props.open}
          onChange={onChange}
        />
      )}
    </DateWrapper>
  );
}

export const mapDispatchToProps = dispatch => ({
  strDate: value => dispatch(startDateMobile(value)),
  edDate: value => dispatch(endDateMobile(value))
});

const mapStateToProps = state => ({
  startDate: state.getIn(['grantsActivity', 'dates', 'start']),
  endDate: state.getIn(['grantsActivity', 'dates', 'end']),
  tab: state.getIn(['grantsActivity', 'tab'])
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateSelectorComponent);
